// extracted by css-extract-rspack-plugin
export default {"double":"BoxDouble__double--z07t1"};